module.exports = __webpack_public_path__ + "img/palm-kayak.fe2c122f.jpg";